import {
  approveSigningReviewResponseSchema,
  getSigningReviewResponseSchema,
  rejectSigningReviewResponseSchema,
  signingNotInReviewResponseSchema,
  signingReviewAlreadyApprovedResponseSchema,
  signingReviewAlreadyRejectedResponseSchema,
  signingReviewNotFoundResponseSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

// Extend request objects only for the frontend with necessary path params
const CRUD = {
  r: z.object({ reviewerStatusId: z.string() }),
};

const endpoints = {
  'review.get': {
    method: 'GET',
    url: `${API_URL_BASE}reviews/:reviewerStatusId`,
    requestSchema: CRUD.r,
    responseSuccessSchema: getSigningReviewResponseSchema,
    requiresToken: 'session',
    responseErrorSchemas: {
      400: signingNotInReviewResponseSchema,
      404: signingReviewNotFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof CRUD.r,
    typeof getSigningReviewResponseSchema,
    {
      400: typeof signingNotInReviewResponseSchema;
      404: typeof signingReviewNotFoundResponseSchema;
    }
  >,
  'review.approve': {
    method: 'POST',
    url: `${API_URL_BASE}reviews/:reviewerStatusId/approve`,
    requestSchema: CRUD.r,
    responseSuccessSchema: approveSigningReviewResponseSchema,
    requiresToken: 'session',
    responseErrorSchemas: {
      400: signingNotInReviewResponseSchema,
      404: signingReviewNotFoundResponseSchema,
      409: signingReviewAlreadyApprovedResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof CRUD.r,
    typeof approveSigningReviewResponseSchema,
    {
      400: typeof signingNotInReviewResponseSchema;
      404: typeof signingReviewNotFoundResponseSchema;
      409: typeof signingReviewAlreadyApprovedResponseSchema;
    }
  >,
  'review.reject': {
    method: 'POST',
    url: `${API_URL_BASE}reviews/:reviewerStatusId/reject`,
    requestSchema: CRUD.r,
    responseSuccessSchema: rejectSigningReviewResponseSchema,
    requiresToken: 'session',
    responseErrorSchemas: {
      400: signingNotInReviewResponseSchema,
      404: signingReviewNotFoundResponseSchema,
      409: signingReviewAlreadyRejectedResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof CRUD.r,
    typeof rejectSigningReviewResponseSchema,
    {
      400: typeof signingNotInReviewResponseSchema;
      404: typeof signingReviewNotFoundResponseSchema;
      409: typeof signingReviewAlreadyRejectedResponseSchema;
    }
  >,
};

export default endpoints;
